module.exports = __webpack_public_path__ + "img/pantalla-9-1.eb5ac48d.png";